import './winmock13/style';
import FormStructure from './winmock13/form_structure';

export default FormStructure;